/**
 * 商品
 */

import { HTTP_ALB } from '../axios'

//  商品列表
export const getcategorylist = params => {
  return HTTP_ALB.get('/system/category/list', params)
}

// 添加商品
export const addcategory = params => {
  return HTTP_ALB.post('/system/category/add', params)
}
// 编辑商品
export const editcategory = params => {
  return HTTP_ALB.post('/system/category/edit', params)
}


